import * as React from "react";
import styled from "styled-components";
import { ActionButtonsDisplay } from "widgets/ActionButtons";
import { FiMenu, FiPlusCircle } from "react-icons/fi";
import { MdClose, MdFullscreen } from "react-icons/md";
import { useSidebar } from "modules/ui";
import toggleFullscreen, { isFullscreen } from "toggle-fullscreen";
import { useComponents, useLoadingComponent } from "modules/components";
import * as components from "modules/components";
import { useLocation } from "react-router-dom";
import config from "config";
import theme from "theme";

export default function Header() {
  const sidebar = useSidebar();
  const loading = useLoadingComponent();
  const components = useComponents();
  const location = useLocation();

  const routeName = React.useMemo(() => {
    if (location.pathname === "/") return "Components";
    if (location.pathname === "/settings") return "Settings";
    const match = location.pathname.match(/^\/grid\/(.+)/);
    if (match) {
      const ms = config.mediaSizes.find((m) => m.key === match[1]);
      return ms ? ms.label : match[1];
    }
    return "";
  }, [location.pathname]);
  const [isModalVisible, setModalVisible] = React.useState(false);
  const [component, setComponent] =
    React.useState<components.t.Component | null>(null);

  const handleFullscreenClick = () => {
    loading.isLoading ? setModalVisible(true) : toggleFullscreen(document.body);
  };

  React.useEffect(() => {
    const listener = (e: any) => {
      if (typeof e.data !== "object" || !e.data.type) return;
      if (e.data.type === "fireside-update-component") {
        setComponent({ ...e.data.component });
      }
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [loading.data]);

  const saveAndOpenFullscreen = () => {
    loading.data
      ? loading.update(loading.data.id, component)
      : loading.add(component);
    openFullScreen();
  };

  const openFullScreen = () => {
    setModalVisible(false);
    loading.unload();
    toggleFullscreen(document.body);
  };

  return (
    <>
      {isModalVisible && (
        <FullscreenModalWrapper>
          <div className="box">
            <button onClick={saveAndOpenFullscreen} className="green">
              Save changes & {isFullscreen() ? "close" : "open"} fullscreen
            </button>
            <button onClick={openFullScreen} className="red">
              {isFullscreen() ? "Close" : "Open"} Fullscreen <b>without</b> save
            </button>
            <button onClick={() => setModalVisible(false)}>Cancel</button>
          </div>
        </FullscreenModalWrapper>
      )}
      <Offset />
      <Wrapper>
        <div
          className="burger-menu"
          onClick={sidebar.isOpen ? sidebar.close : sidebar.open}
        >
          {/* @ts-expect-error react-icons types not yet compatible with React 19 types */}
          {sidebar.isOpen ? <MdClose /> : <FiMenu />}
        </div>
        <div className="route-name">{routeName}</div>
        <ActionButtonsDisplay />
        {!loading.isLoading &&
          location.pathname === "/" &&
          components.data.length > 0 && (
            <div className="add" onClick={() => loading.load()}>
              {/* @ts-expect-error react-icons types not yet compatible with React 19 types */}
              <FiPlusCircle />
            </div>
          )}
        <div className="fullscreen" onClick={handleFullscreenClick}>
          {/* @ts-expect-error react-icons types not yet compatible with React 19 types */}
          <MdFullscreen />
        </div>
      </Wrapper>
    </>
  );
}

const Offset = styled.div`
  height: 60px;
  width: 100%;
`;

const Wrapper = styled.div`
  /* the 60px height is mirrored by the sidebar, the storybook overlay and the
     grid height, do not change it here alone */
  height: 60px;
  background: ${theme.color.accent};
  box-shadow: ${theme.shadow};
  display: flex;
  align-items: center;
  padding: 0 6px;
  position: fixed;
  z-index: 99999;
  left: 0;
  right: 0;
  top: 0;

  > .burger-menu,
  > .fullscreen,
  > .add {
    cursor: pointer;
    height: 36px;
    width: 36px;
    margin: 0 2px;
    border-radius: ${theme.radius};
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    flex-shrink: 0;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }

    > svg {
      color: white;
      font-size: 22px;
    }
  }

  > .route-name {
    flex: 1;
    min-width: 0;
    margin-left: 8px;
    color: white;
    font-family: ${theme.font};
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const FullscreenModalWrapper = styled.div`
  position: fixed;
  right: 5px;
  top: 0;
  z-index: 999999;

  > .box {
    background: steelblue;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    column-gap: 5px;

    > button {
      height: 50px;
      flex: 1;
      border: none;
      cursor: pointer;

      &:hover {
        background: rgb(221, 221, 221);
      }
    }

    .green {
      background-color: rgb(0, 150, 136);
      color: white;

      &:hover {
        background-color: rgb(0, 165, 148);
      }
    }

    .red {
      background-color: rgb(233, 30, 99);
      color: white;

      &:hover {
        background-color: rgb(243, 33, 103);
      }
    }
  }
`;
